import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Select } from 'antd';

const { Option } = Select;

const PlacesAdminComponent = ({ countries, onCountrySelected, countrySelected, provinces, onProvinceSelected, provinceSelected, cities, onCitySelected, citySelected }) => {
    
    const [form] = Form.useForm();
    
    const onCountrySelect = value => {
        form.setFieldsValue({
            field_none_province: undefined,
            field_none_city: undefined
        })
        onCountrySelected(value)
    }

    const onProvinceSelect = value => {
        form.setFieldsValue({
            field_none_city: undefined,
        })
        onProvinceSelected(value)
    }

    return (
        <Grid>
            <Form form={form}>
                <Row center="xs">
                    <Col xs={12} sm={8} md={4}>
                        <Form.Item name="field_none_country" rules={[{ required: false, message: 'Por favor, seleccione un país' }]}>
                            <Select placeholder="País" onSelect={onCountrySelect}>
                                {
                                    countries && countries.map(country => <Option key={country} value={country}>{country}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={8} md={4}>
                        <Form.Item name="field_none_province" rules={[{ required: false, message: 'Por favor, seleccione una provincia' }]}>
                            <Select placeholder="Provincia" onSelect={onProvinceSelect}>
                                {
                                    provinces && provinces.map(province => <Option key={province} value={province}>{province}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={8} md={4}>
                        <Form.Item name="field_none_city" rules={[{ required: false, message: 'Por favor, seleccione una ciudad' }]}>
                            <Select placeholder="Ciudad" onSelect={onCitySelected}>
                                {
                                    cities && cities.map(city => <Option key={city} value={city}>{city}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
    );
};

PlacesAdminComponent.propTypes = {
    countries: PropTypes.array,
    provinces: PropTypes.array,
    cities: PropTypes.array,
};

export default PlacesAdminComponent;